// DashboardLayout.jsx
import { useEffect, useState } from "react";
import Header from "../../DashBoardMenu/HeaderComponent/Header";
import SideBarMenuDashboard from "../../SideBarMenu/SideBarMenuDashbaord";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { FetchEmployeePermissions } from "../../../services/apiService";
import { getAdminProfile } from "../../../services/authService";
import { ShieldCheck } from "lucide-react";

const DashboardLayout = () => {
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const pathName = window.location.pathname.replace("/", "");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getAdminProfile();
        if (res?.data?.user_id) {
          setUserProfile(res?.data);
          setUser(res?.data);
        }
      } catch (error) {
        console.error("Error fetching mobile number", error);
      }
    };
    fetchProfile();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await FetchEmployeePermissions({
        user_id: userProfile?.user_id,
      });

      //  console.log("Permissions API Response:", res);

      if (res) {
        const routes = res?.data?.permissions || [];
        const filteredPermissions = routes
          .filter((item) => item.status)
          .map((item) => item.url);
        // console.log("Filtered Permissions:", filteredPermissions);

        setSelectedPermissions(filteredPermissions);
      }
    } catch (error) {
      console.log("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    if (!userProfile?.user_id) return;
    fetchPermissions();
  }, [userProfile?.user_id]);

  useEffect(() => {
    if (selectedPermissions.length === 0) return;
    console.log("selectedPermissions");

    if (selectedPermissions.includes(pathName)) {
      setPermissionLoading(false);
    } else {
      setPermissionLoading(false);
      navigate("/admin-dashboard");
    }
  }, [selectedPermissions]);

  

  return (
    <div className="min-h-screen flex flex-col">
      <Header user={user} />

      <SideBarMenuDashboard
        setSidebarStatus={setIsSidebarOpen}
        setUser={setUser}
      />

      <main
        className={` transition-all duration-300
    ${isSidebarOpen ? "md:ml-[300px]" : "md:ml-[110px]"}`}
      >
        <div className="min-h-screen">
          {permissionLoading ? (
            <div className="fixed inset-0 z-50 flex flex-col items-center justify-center overflow-hidden bg-slate-950 font-sans">
              {/* Subtle Animated Background Grid & Glow */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(14,165,233,0.15)_0%,transparent_70%)] animate-pulse pointer-events-none" />
              <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b15_1px,transparent_1px),linear-gradient(to_bottom,#1e293b15_1px,transparent_1px)] bg-[size:4rem_4rem]" />

              {/* Loader Graphic Container */}
              <div className="relative flex items-center justify-center w-40 h-40">
                {/* Outer Rotating Ring with Gradient Border */}
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-cyan-400 border-r-blue-600 animate-[spin_2s_linear_infinite] shadow-[0_0_25px_rgba(6,182,212,0.4)]" />

                {/* Middle Counter-Rotating Dashed Ring */}
                <div className="absolute inset-2 rounded-full border-2 border-dashed border-cyan-500/40 animate-[spin_3s_linear_infinite_reverse]" />

                {/* Inner Glowing Core Ring */}
                <div className="absolute inset-6 rounded-full border-4 border-cyan-400/20 animate-ping" />
                <div className="absolute inset-6 rounded-full bg-gradient-to-tr from-cyan-500/20 to-blue-600/20 backdrop-blur-md border border-cyan-500/30 flex items-center justify-center shadow-lg">
                  {/* Icon with Subtle Pulse */}
                  <ShieldCheck className="w-10 h-10 text-cyan-400 animate-pulse drop-shadow-[0_0_10px_rgba(34,211,238,0.8)]" />
                </div>

                {/* Orbiting Satellite Particle */}
                <div className="absolute inset-0 animate-[spin_1.5s_linear_infinite]">
                  <div className="w-3 h-3 bg-cyan-300 rounded-full shadow-[0_0_12px_#22d3ee] translate-x-16 translate-y-16" />
                </div>
              </div>

              {/* Animated Text Section */}
              <div className="mt-8 flex flex-col items-center space-y-2 z-10">
                <h3 className="text-xl font-bold tracking-widest uppercase text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-sky-300 to-blue-500 animate-pulse">
                  Verifying Permissions
                </h3>

                {/* Bouncing Dot Wave Indicator */}
                <div className="flex items-center space-x-1.5 text-cyan-400/70 text-sm font-medium">
                  <span>Authenticating session</span>
                  <span className="flex space-x-1 ml-1">
                    <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-bounce [animation-delay:-0.3s]"></span>
                    <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-bounce [animation-delay:-0.15s]"></span>
                    <span className="w-1.5 h-1.5 bg-cyan-400 rounded-full animate-bounce"></span>
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <Outlet />
          )}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
